import React, { useState } from "react";
import { CustomComponents } from '../template/CustomTemplate/Pages/templates/CustomComponents';
import AddComponent from "./AddComponent";

const TemplatesInputInputs = () => {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([]);

 

  
  const openData = () => {
    setOpen(true)
  }
  const saveComponent = (id) => {
    setData(item => [...item, id])
    setOpen(false)
  }
  return (
    <div>
      <AddComponent open={open} setOpen={setOpen} saveComponent={saveComponent}></AddComponent>
      <section className="content">
      
        {data.map((data, index) => {
          return <div key={index+""}>     <div className="card">
          <div
            
          >{CustomComponents.component.find(item => item.id === data).component?.preview("english", CustomComponents.component.find(item => item.id === data).component?.sampleData)}</div></div> </div>
        })}
        <div className="container-fluid">
          <div className="input_form">
            <div className="card-footer text-left">
              <button className="btn main_submit" onClick={openData}>
                Add Componets
              </button>
            </div>
          </div>

          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};


export default TemplatesInputInputs;
